import React from 'react';
import PropTypes from 'prop-types';
import { Router } from 'react-router';
import { Provider } from 'react-redux';
import { I18nextProvider } from 'react-i18next';
import i18n from '../../app/i18n';
import LocaleProvider from 'antd/lib/locale-provider';
import skSK from 'antd/lib/locale-provider/sk_SK';
import routes from '../../app/routes';
import { GoogleReCaptchaProvider } from 'react-google-recaptcha-v3';

const Root = ({ store, history }) => {
  let baseName = process.env.REACT_HOMEPAGE_FOLDER

  if(typeof baseName === 'undefined') {
    baseName = 'admin'
  }

  return (
    <GoogleReCaptchaProvider
      reCaptchaKey={process.env.REACT_APP_SITE_KEY}
    >
      <I18nextProvider i18n={i18n}>
        <LocaleProvider locale={skSK}>
          <Provider store={store}>
            <Router onUpdate={() => window.scrollTo(0, 0)} history={history} basename={`/${baseName}`}>
              {routes(store)}
            </Router>
          </Provider>
        </LocaleProvider>
      </I18nextProvider>
    </GoogleReCaptchaProvider>
  )
}

Root.propTypes = {
  store: PropTypes.object.isRequired,
  history: PropTypes.object.isRequired,
};

export default Root;



// WEBPACK FOOTER //
// ./src/app/containers/Root.js